import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE_URL, DASHBOARD_URL, readApiResponse } from '../services/authApi';
import { pageStyle, cardStyle, brandStyle, titleStyle, textStyle, labelStyle, inputStyle, buttonStyle, secondaryButtonStyle, errorStyle, successStyle, helperLinkStyle } from './components/authPageStyles';

function TrocarSenha() {
  const [email, setEmail] = useState('');
  const [temporaryPassword, setTemporaryPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!/\S+@\S+\.\S+/.test(email)) return setError('Informe um e-mail válido.');
    if (temporaryPassword.length < 6) return setError('Informe a senha temporária recebida por e-mail.');
    if (newPassword.length < 6) return setError('A nova senha precisa ter pelo menos 6 caracteres.');
    if (newPassword !== confirmPassword) return setError('As senhas não conferem.');

    setIsSubmitting(true);
    try {
      const loginResult = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim(), password: temporaryPassword }),
      }).then(readApiResponse);

      const accessToken = loginResult?.data?.accessToken || loginResult?.accessToken;
      if (!accessToken) throw new Error('Não foi possível autenticar com a senha temporária.');

      await fetch(`${API_BASE_URL}/api/auth/password/change`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify({ newPassword }),
      }).then(readApiResponse);

      setSuccess('Senha alterada com sucesso! Agora você já pode acessar o dashboard com sua nova senha.');
      setEmail(''); setTemporaryPassword(''); setNewPassword(''); setConfirmPassword('');
    } catch (err) {
      setError(err.message || 'Não foi possível trocar a senha.');
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <main style={pageStyle}>
      <section style={cardStyle}>
        <div style={brandStyle}>RE</div>
        <h1 style={titleStyle}>Trocar senha</h1>
        <p style={textStyle}>Use a senha temporária recebida por e-mail para definir uma nova senha de acesso.</p>
        {error && <div style={errorStyle}>{error}</div>}
        {success && <div style={successStyle}>{success}</div>}
        {!success ? (
          <form onSubmit={handleSubmit}>
            <label style={labelStyle}>E-mail</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="seuemail@realenergy.com.br" style={inputStyle} />
            <label style={labelStyle}>Senha temporária</label>
            <input type="password" value={temporaryPassword} onChange={(e) => setTemporaryPassword(e.target.value)} placeholder="Senha temporária recebida por e-mail" style={inputStyle} />
            <label style={labelStyle}>Nova senha</label>
            <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="Digite sua nova senha" style={inputStyle} />
            <label style={labelStyle}>Confirmar nova senha</label>
            <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Repita sua nova senha" style={inputStyle} />
            <button type="submit" disabled={isSubmitting} style={{ ...buttonStyle, opacity: isSubmitting ? 0.7 : 1 }}>{isSubmitting ? 'Alterando senha...' : 'Alterar senha'}</button>
          </form>
        ) : <a href={DASHBOARD_URL} style={secondaryButtonStyle}>Acessar dashboard</a>}
        <div style={{ display: 'grid', gap: '10px', marginTop: '18px' }}>
          <Link to="/recuperar-senha" style={helperLinkStyle}>Solicitar nova senha temporária</Link>
          <Link to="/" style={helperLinkStyle}>Voltar para o site</Link>
        </div>
      </section>
    </main>
  );
}

export default TrocarSenha;
